// extracted by mini-css-extract-plugin
export default {"poll_success_container":"pollsuccess_poll_success_container__SeIBw","card":"pollsuccess_card__PsR46","icon":"pollsuccess_icon__UXDp8","kicker":"pollsuccess_kicker__QcXzr"};